export default __webpack_public_path__ + "media/images/features/yado/step_1_text-754bde13892a3a97095e6e983dc9ffaa.png";